// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2875":"50abde7b","6306":"853c1a77"}[chunkId] + ".chunk.css";
};